import * as React from "react";
import { Link, NavLink } from "react-router-dom";
import classNames from "classnames";
import { ProjectStore } from "modules/project/ProjectStore";
import { withStyles } from "@material-ui/core/styles";
import { Explore, Widgets, MonetizationOn } from "@material-ui/icons";
import { Cube, Rubk } from "common/icons";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { Tooltip } from "@material-ui/core";
import { LibraryStore } from "modules/library/LibraryStore";
import { observer } from "mobx-react";
import { WBSStore } from "modules/WBS/WBSStore";
import { Render3dStore } from "modules/render3D/Render3dStore";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import i18n from "i18n";
import { gtag } from "ga-gtag";
import { ELeftMenuTab, EWBSView } from "common/enums";

const styles = (theme) => ({
  container: {
    width: "40px",
    display: "flex",
    paddingBottom: "85px",
    backgroundColor: "#000",
    flexFlow: "column nowrap",
    position: "relative" as any,
    zIndex: 1000,
  },
  itemEnd: {
    marginTop: "auto",
  },
  item: {
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    color: "#999",
    "&:hover": {
      color: "#FFFFFF",
    },
    transition: "all 0.3s ease-in",
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: "none" as any,
  },
  itemTest: {
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    color: "#999",
    "&:hover": {
      color: "#FFFFFF",
    },
    transition: "all 0.3s ease-in",
    marginTop: "auto",
    marginBottom: "9.5px",
  },
  activeTab: {
    color: "#ABC200",
  },
  icon: {
    fontSize: "21px",
  },
  iconTest: {
    fontSize: "21px",
    marginTop: "auto",
  },
});

type IProps = {
  classes: any;
};

@observer
class LeftSideMenuController extends React.Component<IProps> {
  constructor(props: any) {
    super(props);
  }

  state = {
    currentTab: ELeftMenuTab.CLOSED,
  };

  handleChangeLeftMenuTab = (index) => () => {
    const { currentTab } = this.state;
    const newTabIndex = index === currentTab ? ELeftMenuTab.CLOSED : index;
    ProjectStore.leftTab = newTabIndex;
    this.setState({ currentTab: newTabIndex });
  };

  renderTab = (
    index: number,
    Icon: React.ComponentType<any>,
    title: string,
    end: boolean
  ) => (
    <Tooltip title={title} placement="right">
      <div
        className={classNames(
          this.props.classes.item,
          end && this.props.classes.itemEnd
        )}
        onClick={this.handleChangeLeftMenuTab(index)}
      >
        <Icon
          className={classNames(
            this.props.classes.icon,
            this.state.currentTab === index && this.props.classes.activeTab
          )}
        />
      </div>
    </Tooltip>
  );

  componentDidMount() {
    LibraryStore.fetchLibraries();
  }

  handleTabsChange = async (value) => {
    Render3dStore.resetSectionPlane();

    if (WBSStore.currentTab == EWBSView.EAP) {
      WBSStore.cubeIsInitialized = true;
      this.setState({ currentTab: value });
      await WBSStore.get3dModel(WBSStore.WBS.id);
      WBSStore.handle3DTabXeokit();
      if (WBSStore.possibleLoading) {
        Render3dStore.loadingViewer = true;
      }
      WBSStore.openViewer3D();
    } else {
      WBSStore.cubeIsInitialized = false;
      this.setState({ currentTab: 5 });
      WBSStore.openEAP();
    }
    TakeOffStore.layerTakeOffList = false;
  };

  handleNavClick = (e) => {
    if (LibraryStore.libraries.length === 0) {
      e.preventDefault();
    }
  };

  render() {
    return (
      <div className={this.props.classes.container}>
        <Link
          className={this.props.classes.item}
          style={{ height: "33px", color: "#fff" }}
          to={"/menu/development"}
        >
          <Rubk className={this.props.classes.icon} />
        </Link>
        {this.renderTab(
          ELeftMenuTab.NAVIGATOR,
          Explore,
          i18n.project.leftSideMenu.navigator,
          false
        )}
        {this.renderTab(
          ELeftMenuTab.LIBRARIES,
          Widgets,
          i18n.project.leftSideMenu.library,
          false
        )}
        {this.renderTab(
          ELeftMenuTab.COST_PLANS,
          MonetizationOn,
          i18n.project.leftSideMenu.costPlan,
          true
        )}

        <Tooltip title={i18n.project.leftSideMenu.viewer} placement="right">
          <div className={classNames(this.props.classes.item)}>
            <Cube
              onClick={(e) => {
                gtag("event", "abrir_viewer", {
                  abrir_viewer: 0,
                });

                this.handleTabsChange(e);
              }}
              className={
                WBSStore.currentTab != EWBSView.EAP
                  ? this.props.classes.activeTab
                  : this.props.classes.icon
              }
              style={{ fontSize: "20px" }}
            />
          </div>
        </Tooltip>
      </div>
    );
  }
}
export default withStyles(styles)(LeftSideMenuController);



// WEBPACK FOOTER //
// ./src/modules/project/components/layouts/LeftSideMenuController.tsx